import { useOrgContext } from '@/org/contexts/OrgContext'
import { useContext, useMemo } from 'react'
import { MeetingContext } from '../contexts/MeetingContext'

export interface MeetingOrigin {
  meetingId: string
  circleId: string
  circleName: string
  // The meeting's circle, its roles and sub-circles: the same scope as the
  // meeting's Projects step and next steps (REU12-D1).
  circleIds: string[]
}

// #123: the meeting a form was opened from, if any. Read from MeetingContext,
// which crosses portals: a modal opened inside the meeting sees it, one opened
// from the sidebar does not — even while a meeting is running, which is the
// rule Yohan chose. A finished meeting no longer counts (G2-D17).
export default function useMeetingOrigin(): MeetingOrigin | undefined {
  const meetingState = useContext(MeetingContext)
  const { orgData } = useOrgContext()
  const meetingId = meetingState?.meeting?.id
  const circle = meetingState?.isEnded ? undefined : meetingState?.circle

  return useMemo(() => {
    if (!meetingId || !circle || !orgData) return undefined
    return {
      meetingId,
      circleId: circle.id,
      circleName: orgData.getRole(circle.roleId)?.name ?? '',
      circleIds: orgData.circleWithChildren(circle.id).map((c) => c.id),
    }
  }, [meetingId, circle, orgData])
}
